module.exports = " <div class=input_area _v-49304f2c=\"\"> <textarea v-model=enterContent @keyup.enter=sendArbiter _v-49304f2c=\"\"></textarea> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-49304f2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/InputArea.vue
 ** module id = 346
 ** module chunks = 2
 **/